module.exports = __webpack_public_path__ + "static/media/fondo_mariachi.dec56564.jpg";